"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.set = exports.counter = exports.input = exports.radio = exports.toggle = exports.paginator = undefined;

var _redux = require("redux");

var _toggle = require("./reducer/toggle");

var _toggle2 = _interopRequireDefault(_toggle);

var _radio = require("./reducer/radio");

var _radio2 = _interopRequireDefault(_radio);

var _input = require("./reducer/input");

var _input2 = _interopRequireDefault(_input);

var _counter = require("./reducer/counter");

var _counter2 = _interopRequireDefault(_counter);

var _paginator = require("./reducer/paginator");

var _paginator2 = _interopRequireDefault(_paginator);

var _set = require("./reducer/set");

var _set2 = _interopRequireDefault(_set);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
    paginator: _paginator2.default,
    toggle: _toggle2.default,
    radio: _radio2.default,
    input: _input2.default,
    counter: _counter2.default,
    set: _set2.default
});
exports.paginator = _paginator.paginator;
exports.toggle = _toggle.toggle;
exports.radio = _radio.radio;
exports.input = _input.input;
exports.counter = _counter.counter;
exports.set = _set.set;